import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';

@Component({
  selector: 'app-print-client-bank-details',
  templateUrl: './print-client-bank-details.component.html',
  styleUrls: ['./print-client-bank-details.component.scss']
})
export class PrintClientBankDetailsComponent implements OnInit {

  bankAccounts: [] = [];
  clientName: string;

  constructor(
    private printService: PrintService,
  ) {
    this.bankAccounts = this.printService.data.bankAccounts;
    this.clientName = this.printService.data.clientName;
  }

  ngOnInit(): void {
    this.printService.onDataReady('Client Bank Accounts');

  }

}
